/**
 * Created by zuozhuo on 2018/1/18.
 */
import axios from "axios";
import utils from "../utils/utils";
import { Toast } from "foui";
import { foAjaxEncode, foAjaxDecode } from "./ajaxCrypt";
import siteConfig from "../consts/config/index";
import {
  APP_VERSION,
  HTTP_CODE_NEED_AUTH_ARRAY,
  HTTP_CODE_SUCCESS,
  HTTP_CODE_WX_KEY_EXPIRED,
  STORAGE_KEYS,
  URL_LOGIN
} from "../consts/consts";
import foStorage from "../utils/foStorage";

const SERVER_ERROR_MSG = "服务器异常!";
const ENCRYPT_ENABLE = true;

const baseURL = siteConfig.baseUrl;
const ajax = axios.create({
  baseURL
});

function isOurServer(url) {
  return url.startsWith(baseURL);
}

ajax.interceptors.request.use(function(config) {
  // 以下两个不要加, 可能导致浏览器跨域请求禁止
  // config.headers['Access-Control-Allow-Origin'] = true;
  // config.headers['withCredentials'] = true;

  // 请求是否加密
  // const isCrypto = !config.disCrypto && siteConfig.encodeAjaxData;
  const isCrypto = false;

  if (config.method === "post") {
    const bodyData = config.data || {};
    bodyData.t = new Date().getTime();

    config.data = isCrypto ? foAjaxEncode(bodyData) : bodyData;
  }

  if (isOurServer(config.url)) {
  }

  const platform = 3; //  //1 iOS; 2 Android; 3 微信 4小程序
  const version = APP_VERSION;
  const metaHeaders = {
    k: 3,
    // 告知服务器, 当前请求是否做body加密
    f: isCrypto ? 0 : 1,
    t: foStorage.getItem(foStorage.KEYS.token),
    v: version,
    p: platform,
    w: utils.getOrganizationWechatAppId()
  };
  // console.log("加密前的header");
  // console.log(JSON.stringify(metaHeaders));
  const encodeHeader = foAjaxEncode(metaHeaders);
  config.headers = {
    // h_raw: JSON.stringify(metaHeaders),
    // h: encodeHeader,
    // p: platform,

    Authorization: foStorage.getItem(foStorage.KEYS.token)
  };
  // console.log("传输的header");
  // console.log(JSON.stringify(config.headers));

  return config;
});

function toastErrorMessage({ msg, config, code }) {
  if (msg === "Network Error") {
    msg = "网络不给力";
  }

  // 这里设置一个定时器, 是为了后面将toast关闭(因为toast是一个全局单例)
  setTimeout(() => {
    if (config.silence) {
      return;
    }
    if (
      config.silenceCodes &&
      code &&
      [].concat(config.silenceCodes).includes(code)
    ) {
      return;
    }
    Toast.fail(msg || SERVER_ERROR_MSG);
  }, 100);
}

export function request(config = {}) {
  let { url, method, data, params } = config;
  method = method || "get";
  // params = processGetParams(params, config);
  // data = processPostData(data, config);

  const finalConfig = {
    ...config,
    url,
    method,
    data,
    params
  };

  return (
    ajax
      .request(finalConfig)
      // https://github.com/mzabriskie/axios#response-schema
      .then(function(response) {
        // eslint-disable-next-line
        const { config, data, headers, request, status, statusText } = response;

        let error = undefined;

        if (data) {
          // 服务器要求登录
          if (HTTP_CODE_NEED_AUTH_ARRAY.includes(data.status_code)) {
            utils.redirectToLogin();

            error = new Error("need auth");
          } else if (data.status_code === HTTP_CODE_WX_KEY_EXPIRED) {
            // 返回 4000, 说明 wxAuthKey 已经过期, 所以需要删除
            foStorage.removeItem(foStorage.KEYS.wxAuthKey);
            window.location.reload();
          } else if (data.status_code === 1003) {
            // 返回 1003, 需要完善资料
            utils.redirectToPerfectInfo();
            error = new Error("need info");
          } else if (data.status_code !== HTTP_CODE_SUCCESS) {
            // 其他服务器错误
            const errorMsg = data.message || data.msg || SERVER_ERROR_MSG;
            toastErrorMessage({
              msg: errorMsg,
              config,
              code: data.status_code
            });

            error = new Error("server error");
          }
        }

        // OK
        return {
          response,
          data,
          _data: data ? data.data : null,
          _list: data && data.data && data.data.list ? data.data.list : null,
          error: error
        };
      })
      // https://github.com/mzabriskie/axios#handling-errors
      .catch(function(error) {
        const {
          config, // 传入axios的config
          response, // 如果是 response 的错误
          request, // 如果是 request 的错误
          message // Error类的 message
        } = error;

        // 未登录的情况单独处理
        if (response && (response.status === 401 || response.status === 403)) {
          utils.redirectToLogin();
          return {
            error,
            response,
            data: response.data
          };
        }

        if (request) {
          toastErrorMessage({ msg: message, config });
          return {
            error,
            request
          };
        } else if (response) {
          toastErrorMessage({ msg: message, config });
          return {
            error,
            response,
            data: response.data
          };
        }
      })
  );
}

export function POST(url, data = {}, config = {}) {
  return request({
    ...config,
    method: "post",
    url,
    data
  });
}

export function GET(url, params = {}, config = {}) {
  return request({
    ...config,
    method: "get",
    url,
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/ajax.js